import { Component } from '@angular/core';

@Component({
    selector: 'm4u-gridbottomcontainer',
    templateUrl: './grid-bottom-container.component.html',
    styleUrls: ['./grid-bottom-container.component.scss']
})
export class GridBottomContainerComponent { } //TODO: delete
